import { CalendarAppointmentDisplay } from "@/Appointments/Models/Calendar/CalendarAppointmentDisplay";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

interface IAddContactPointWarningProps {
    deletionEventInfo: kendo.data.SchedulerEvent & CalendarAppointmentDisplay;
    onClose?: () => void;
    onDelete?: () => void;
}

function DeleteAppointmentConfirmationPopup(props: IAddContactPointWarningProps): JSX.Element {
    const { getText } = useTranslation();

    const isReadOnlyEvent = props.deletionEventInfo?.IsReadOnly;
    if (isReadOnlyEvent) { // Show a warning instead
        return (
            <Modal
                fixedOverlayPosition
                showOverlay
                centerContent
                draggable
                showX
                width={465}
                disableOverlayClose
                title={getText("WarningLabel").toTitleCase()}
                onClose={props.onClose}
                footer={(
                    <div className="flex-display flex-end">
                        <ButtonGroup>
                            <ButtonControl
                                onClick={props.onClose}
                                label={getText("CloseLabel")}
                                className="btn btn-default"
                            />
                        </ButtonGroup>
                    </div>
                )}
            >
                <div className="p-body">
                    <div>{getText("AppointmentCancellation_ConfirmationMessageLabel_ReadOnly")}</div>
                </div>
            </Modal>
        );
    }

    return (
        <Modal
            fixedOverlayPosition
            showOverlay
            centerContent
            draggable
            showX
            width={465}
            disableOverlayClose
            title={getText("AppointmentCancellation_ConfirmationLabel")}
            onClose={props.onClose}
            footer={(
                <div className="flex-display flex-end">
                    <ButtonGroup>
                        <ButtonControl
                            onClick={props.onClose}
                            label={getText("CancelLabel")}
                            className="btn btn-default"
                        />
                        <ButtonControl
                            onClick={props.onDelete}
                            dataCy="deleteAppointmentConfirmationPopup-delete-button"
                            label={getText("DeleteLabel")}
                            className="btn btn-danger"
                        />
                    </ButtonGroup>
                </div>
            )}
        >
            <div className="p-body">
                <div style={{ marginBottom: 20 }}>
                    <strong>{getText("AppointmentCancellation_ConfirmationMessageLabel")}</strong>
                </div>
                <div>{getText("AppointmentCancellation_ActionCanNotBeUndoneLabel")}</div>
            </div>
        </Modal>
    );
}

export { DeleteAppointmentConfirmationPopup };
